// TODO: remove once polyfilled
export function findIndex(items, cb) {
    let index = -1;

    items.some((item, i) => {
        if (cb(item)) {
            index = i;
            return true;
        }

        return false;
    });

    return index;
}

const SORT_DIR = {
    ASC([a], [b]) {
        return a - b;
    },
    DESC([a], [b]) {
        return b - a;
    }
};

function sortBy({items, sortValue, compare}) {
    return items
        .map((item) => [sortValue(item), item])
        .sort(compare)
        .map(([, item]) => item);
}

export function sortByAsc({items, sortValue}) {
    return sortBy({
        items,
        sortValue,
        compare: SORT_DIR.ASC
    });
}

export function sortByDesc({items, sortValue}) {
    return sortBy({
        items,
        sortValue,
        compare: SORT_DIR.DESC
    });
}
